export const FORM_ID = {
  GP: 'FORM_FA_GP',
  AU: 'FORM_FA_AU',
};
export const CONFIRMATION_ID = {
  GP: 'CONFIRMATION_FA_GP',
  AU: 'CONFIRMATION_FA_AU',
};
export const CONFIRM_PATH = {
  dev: '/gp/fa/confirmacion/',
  qa: '/order/gp/fa/confirmacion/',
  prod: '/order/gp/fa/confirmacion/',
};
export const URL_SEO = 'www.movistar.es/order/gp/fa';
export const PATH_NAME = {
  GP: '/order/gp/fa',
  AU: '/order/gp/fa',
};
export const NEXT_STEPS = {
  ALTA: 'Te llamaremos en los próximos días para concertar una cita para la instalación.',
  MIGRA: 'Tu cambio se hará efectivo en las próximas 24 - 48 horas laborables.',
  CAMBIOVELOCIDAD:
    'Tu cambio se hará efectivo en las próximas 24 - 48 horas laborables.',
};

export const CLIENT_ORION_TEXTS_IDS = {
  NEXT_STEPS: 'textos-carro'
}
export const PHONE_900 = '900 220 130';
export const HOME_URL =
  'https://www.movistar.es/fibra-optica/segunda-residencia/';
export const TRANSACTION_TYPE = 'fibra-adicional';
